(function (angular) {
	'use strict';

	angular
		.module('subscriptionPreferencesCenterModule')
		.controller('SubscriptionPreferencesCenter', [
			'globalConfig',
			SubscriptionPreferencesCenterFunction
		]);

	function SubscriptionPreferencesCenterFunction(globalConfig) {
		var subscriptionPrefs = this;

		subscriptionPrefs.changePreferences = function(source) {
			if (source === 'allMarketingEmailsOptOut') {
				subscriptionPrefs.serializedForm.investmentUpdateEmails = false;
				subscriptionPrefs.serializedForm.newProductAndFeatureAnnouncementEmails = false;
				subscriptionPrefs.serializedForm.contentAndReminderEmails = false;
				subscriptionPrefs.serializedForm.allMarketingEmailsOptOut = true;
			} else {
				subscriptionPrefs.serializedForm.allMarketingEmailsOptOut = false;
			}
		};

		subscriptionPrefs.$onInit = function() {
			subscriptionPrefs = angular.extend(subscriptionPrefs, globalConfig);
		};
	}
})(window.angular);